import { render, staticRenderFns } from "./ReminderCard.vue?vue&type=template&id=9a49dff8&scoped=true"
import script from "./ReminderCard.vue?vue&type=script&lang=js"
export * from "./ReminderCard.vue?vue&type=script&lang=js"
import style0 from "./ReminderCard.vue?vue&type=style&index=0&id=9a49dff8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a49dff8",
  null
  
)

export default component.exports